import { module } from "angular";
import type { Observable } from "rxjs";
import type { IHttpService } from "App/Modules/Services";
import type { IResponse, INotificationConfiguration } from "../../Models";
import type { INotificationConfigurationsRepository } from "./INotificationConfigurationsRepository";

export default class NotificationConfigurationsRepository implements INotificationConfigurationsRepository {
    public static $inject = ["mmHttpService", "irRolesRepository"];

    constructor(private readonly httpService: IHttpService) {}

    public getNotificationConfigurations(siteId: string): Observable<IResponse<INotificationConfiguration[]>> {
        return this.httpService.get<INotificationConfiguration[]>(`sites/${siteId}/notificationconfigurations`);
    }

    public getARCNotificationConfiguration(siteId: string): Observable<IResponse<INotificationConfiguration>> {
        return this.httpService.get<INotificationConfiguration>(`sites/${siteId}/arcnotificationconfiguration`);
    }

    public patchNotificationConfiguration(
        siteId: string,
        configurationId: string,
        delta: INotificationConfiguration,
    ): Observable<IResponse<INotificationConfiguration>> {
        return this.httpService.patch<INotificationConfiguration>(
            `sites/${siteId}/notificationconfigurations/${configurationId}`,
            delta,
        );
    }
}

module("mmRepositories").service("mmNotificationConfigurationsRepository", NotificationConfigurationsRepository);
